module.exports = __webpack_public_path__ + "static/media/slider1.4074157c.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/slider1.jpeg
// module id = 302
// module chunks = 0